import './style.scss'

export function StepNumber({ number = 1, primary = false }) {
  return <span className={`step-number ${primary ? '-primary' : ''}`}>{number}</span>
}
